import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import { getCurrentCulture } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

import { MyWithdrawalsBody } from "../my-withdrawals";
import { NewWithdrawalBody } from "../new-withdrawal";

export default function WithdrawalTabs() {
	return (
		<Switch>
			<Route exact path={["/:culture/withdrawal"]}>
				<NewWithdrawalBody />
			</Route>

			<Route exact path={["/:culture/withdrawal/history"]}>
				<MyWithdrawalsBody />
			</Route>

			<Redirect to={`/${getCurrentCulture()}/${DefaultPath.HOME}`} />
		</Switch>
	);
}
